import React, {
  useEffect,
  useState,
} from "react";
import './App.scss';
import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import sanityClient from "./client.js";
import Frontpage from './pages/frontpage/frontpage.page';
import Project from './pages/project/project.page';
import About from './pages/about/about.page';
import Contact from './pages/contact/contact.page';

import Cursor from "./components/cursor/cursor.component";
import Menu from './components/menu/menu.component'
import AccessControl from './components/access-control/accessControl.component'
import { useMediaQuery } from 'react-responsive'

function App() {

  const [currentSlug, setCurrentSlug] = useState(null)
  const [currentPage, setCurrentPage] = useState(null)
  const [currentProjectContent, setCurrentProjectContent] = useState(null)
  const [currentProjectNav, setCurrentProjectNav] = useState(null)
  const [frontpageContent, setFrontpageContent] = useState(null)

  const [canAccess, toggleCanAccess] = useState(true)


  const isDesktop = useMediaQuery({ minWidth: 1000 })


  let location = useLocation();  
  // const currentSlug = location.pathname.replace('/','');
  // console.log(currentSlug)

  async function fetchContent(){
    let fetchContentQuery = `{'contact': *[_id == "contact"]{...},'about': *[_id == "about"]{...},'projects':*[_type == "project"]{..., 'videoAssets':videos[]{caption, 'asset': video.asset->{...}},'extraVideoAssets':videosExtra[]{caption,'asset': video.asset->{...}},'phase2VideoAssets':phase2Videos[]{caption,'asset': video.asset->{...}},'phase3VideoAssets':phase3Videos[]{caption,'asset': video.asset->{...}} } | order(order asc)}`;
    fetchContentQuery
    sanityClient
    .fetch(fetchContentQuery)
    .then(data => {setFrontpageContent(data)})
    .catch(console.error)
  }

  useEffect(() =>{
    let access = localStorage.getItem('access');
    if (access == false || access == null){
      
      toggleCanAccess(false)
    }
    // if(frontpageContent == null){
      fetchContent()
    // }
    //check if they can access from localstorage, otherwise set false
    // fetchContent()
  },[location]);

  useEffect(() =>{
    if (!frontpageContent) return
    // console.log('setting')
    const setProjectToState = () =>{
      // console.log('setting project')
      const returnProjectIndexFromSlug = (slug)=>{

        let currentIndex;
        // console.log(frontpageContent.projects)

        for(var i=0;frontpageContent.projects.length > i; i++){
          if (frontpageContent.projects[i].slug.current == slug){
            currentIndex = i
          }
        }

        // console.log(currentIndex)
        return currentIndex
      }
      setCurrentSlug(currentSlug)

      const currentProjectIndex = returnProjectIndexFromSlug(currentSlug)
      const currentProject = frontpageContent.projects[currentProjectIndex]
      const currentProjectNav = {
        'prevSlug': currentProjectIndex > 0 ? frontpageContent.projects[currentProjectIndex-1].slug.current : null,
        'nextSlug': currentProjectIndex < frontpageContent.projects.length-1 ? frontpageContent.projects[currentProjectIndex+1].slug.current : null}
      // console.log(currentProjectIndex)
      // console.log(currentProjectNav)
      // console.log(currentProject)
      
      setCurrentProjectNav(currentProjectNav)
      setCurrentProjectContent(currentProject)
    }

    const currentSlug = location.pathname.replace('/','');
    // console.log(currentSlug)
    if(currentSlug !== null && currentSlug !== ''){
      
      if (currentSlug == 'about'){
        setCurrentPage('about')
      }
      else if (currentSlug == 'contact'){
        setCurrentPage('contact')
      }
      else{
        setCurrentPage('project')
        setProjectToState();
      }
    }else{
      console.log('no page')
      setCurrentPage(null)
    }
  },[frontpageContent])

  // useEffect(() => {

  //   let ticking = false;
  //   let lastKnownScrollPosition;

  //   document.addEventListener("wheel", function(e){

  //     lastKnownScrollPosition = window.scrollY;

  //     if (!ticking) {
  //       window.requestAnimationFrame(function() {
          
  //         ticking = false;
  //       });

  //       ticking = true;
  //     }
  //   });

  //   // return () => {
  //   //   document.removeEventListener("wheel", function(e){ });
  //   // };
  // }, []);

  // useEffect(() =>{ 
  //   if (!frontpageContent){
  //     fetchContent().then(console.log('done')).then(setProjectToState())
  //   }else{
  //     setProjectToState()
  //   }

  // },[location])

  console.log(frontpageContent)
  return (
      <>
      {/* <Desktop> */}
        <Cursor isDesktop={isDesktop} canAccess={canAccess}/>
      {/* </Desktop> */}
      {!canAccess ?
        <AccessControl toggleCanAccess={toggleCanAccess}/>
      :''
      }
      <Menu currentPage={currentPage} />
      <div className={`transition-cover ${currentPage ? 'transition-cover-active' : ''}`}></div>
      
      {currentPage == 'project' ? <Project content={currentProjectContent} currentProjectNav={currentProjectNav} /> :''}
      {currentPage == 'about' ? <About content={frontpageContent.about}/> :''}
      {currentPage == 'contact' ? <Contact content={frontpageContent.contact}/> :''}
      <Routes>
        <Route path="*" element={<Frontpage frontpageContent={frontpageContent} currentPage={currentPage} />} />      
      </Routes>
      </>
  );
}

export default App;
